<template>
  <section class="info-box">
    <h3 class="info-box__title">
      <icon link type="info-circle"></icon>
      <span>
        <slot name="title"></slot>
      </span>
    </h3>
    <slot name="content"></slot>
    <a
      v-for="link in links"
      :href="link.href"
      :key="link.text"
      class="info-box__link"
      target="_blank">
      <icon link type="angle-right"></icon>
      {{ link.text }}
    </a>
  </section>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'af-info-box',
  components: {
    Icon
  },
  props: {
    links: Array,
    onLinkClick: Function
  }
}
</script>

<style lang="postcss" scoped>
.info-box {
  background-color: var(--color-porcelain);
  padding: var(--spacing-half);
  border-radius: 4px;
  padding: var(--spacing);
}

.info-box p {
  margin: 0 0 var(--spacing-half);
}

.info-box__icon {
  margin-right: var(--spacing-third);
}

.info-box__title {
  align-items: center;
  color: var(--color-mine-shaft);
  display: flex;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 15px;
  margin-top: 0;
  text-transform: uppercase;
}

.info-box__title > .icon-wrapper {
  margin-right: var(--spacing-third);
}

.info-box__link {
  color: #13769d;
  display: flex;
  font-weight: 600;
  text-decoration: none;

  & .fa-angle-right {
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AfInfoBox.vue